// extracted by css-extract-rspack-plugin
export default {"floatingWindow":"floatingWindow-l3cDqs","dragging":"dragging-HwouMe","resizing":"resizing-i7XHik","windowContent":"windowContent-sXU6yH","resizeHandle":"resizeHandle-DJ0RjU"};